// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/logos/baloa-logo-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header_unauth {
    background: var(--white-color);
    padding: var(--normal-margin-v) var(--double-margin-h);
    /* box-shadow: var(--shadow); */
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    height: 72px;
    width: 100%;
    z-index: 100;
    top: 0;
}



.header__image {
    height: var(--space-x2);
}

.header__search{
    width: 230px;
    float: right;
}

.header__actions {
    display: grid;
    grid-column-gap: var(--space-half);
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.header__actions__home {
    font-size: 28px;
    margin-right: calc( var(--space-x2) + var(--space-half) );
    cursor: pointer;
    text-align: center;
}

.header__actions__home .baloa-username {
    font-size: var(--space-half-quarter);
    color: var(--basic-gray-color);
}

.header__actions__home .baloa-username.active {
    color: var(--new-green-color);
}

.header__actions-icon.icon-plus {
    background-color: var(--new-green-color);
    color: var(--white-color);
    border-radius: 50%;
    padding: var(--space-half-quarter);
    font-size: calc( var(--space) + var(--space-quarter) );
}

.header__actions__home .hubicon-live_tv1 {
    color: var(--basic-gray-color);
    font-size: 28px;
}

.header__actions__home.active .hubicon-live_tv-1 {
    color: var(--new-green-color);
    font-size: 28px;
}

.header__actions__home .icon-trophy {
    color: var(--basic-gray-color);
    font-size: 28px;
}

.header__actions__home.active .icon-trophy {
    color: var(--new-green-color);
    font-size: 28px;
}

.header__actions__home .icon-home {
    color: var(--basic-gray-color);
}

.header__actions__home.active .icon-home {
    color: var(--new-green-color);
}

.header_unauth__container {
    display: flex;
    align-items: center;
}

.header_unauth__search-container {
    margin-left: calc( var(--space-x3) + var(--space) );
    display: flex;
    align-items: center;
    width: 336px;
}

.header_unauth__search-container .icon-search {
    position: absolute;
    margin-left: var(--space-half-quarter);
    font-size: var(--space-and-half);
    color: #949F9A;
}

.header_unauth__search-container input {
    height: calc( var(--space-x2) + var(--space-half) );
    padding-left: var(--space-x3);
    width: 100%;
    border: none;
    background-color: var(--new-gray-background-color);
    border-radius: var(--space-and-half);
}

.header_unauth__search-container input.baloa-names {
    color: #949F9A;
}

.header_unauth__search-container input:focus {
    outline: none;
}

.header_unauth__login-button{
    margin-left: 40px;
}

.header_unauth__mobile {
    position: fixed;
    top: 0;
    background-color: var(--white-color);
    width: 100%;
    padding: calc( var(--space) + 2px ) var(--space);
    z-index: 2;
    display: flex;
    align-items: center;
}

.header-unauth__mobile, 
.header-unauth__mobile-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-unauth__mobile-actions {
    justify-content: space-around;
}

.header-unauth__mobile-menu .hubicon-menu {
    font-size: var(--space-x2);
    color: var(--primary-very-dark-color);
}

.header-unauth__mobile-menu {
    width: 30%;
    display: flex;
    align-items: center;
}

.header-unauth__mobile-menu .icon-search {
    font-size: calc( var(--space) + 2px );
    color: #949F9A;
    background-color: var(--new-gray-background-color);
    border-radius: 50%;
    padding: var(--space-half);
    margin-left: var(--space);
    font-weight: bold;
}

.header-unauth__mobile-actions {
    width: 70%;
}

.header-unauth__actions__mobile-home {
    display: flex;
    align-items: center;
}

.header-unauth__mobile-actions .header__actions__home,
.header-unauth__mobile-actions .header_unauth__login-button {
    margin: 0;
}

.header-unauth__mobile-actions .icon-home,
.header-unauth__mobile-actions .icon-trophy,
.header-unauth__mobile-actions .hubicon-live_tv1 {
    font-size: var(--space-x2);
}

.header-unauth__mobile-actions .header__actions__home .hubicon-live_tv-1 {
    font-size: var(--space-x2);
}

.header-unauth__mobile-actions .button {
    font-size: var(--space);
    padding: var(--space-half) var(--space-x2);
}

.header-unauth__mobile-actions .icon-plus {
    background-color: var(--new-green-color);
    display: flex;
    justify-content: center;
    align-content: center;
    padding: var(--space-half);
    margin: 0;
    border-radius: 50%;
    color: var(--white-color);
}

.header-unauth__mobile__search-box {
    display: flex;
    align-items: center;
    background-color: var(--white-color);
    padding: 14px 16px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 3;
}

.header-unauth__mobile__search-box .icon-arrow-left {
    font-size: calc( var(--space) + var(--space-half));
    margin-right: var(--space-and-half);
}

.header-unauth__mobile__search-box .search-form__form input[type=text] {
    padding: var(--space-half) var(--space-half) var(--space-half) var(--space-x3)
 }

.header-unauth__mobile__search-box .search-form__form .MuiSvgIcon-root {
    margin: calc( var(--space-quarter) + 1px );
}

.header-unauthenticated__baloa-landing {
    background-color: #EAF7F0;
    padding: 12px;
    gap: 8px;
    white-space: nowrap;
}

@media screen and ( max-width: 576px ) {
    
    .header__image {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }
    
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .header__actions__home {
        font-size: unset;
    }
    .header__actions__home.active .icon-trophy {
        font-size: var(--space-x2);
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/header-unauthenticated/HeaderUnauthenticatedComponent.styles.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,sDAAsD;IACtD,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,MAAM;AACV;;;;AAIA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yDAAyD;IACzD,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;IAClC,sDAAsD;AAC1D;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mDAAmD;IACnD,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,mDAAmD;IACnD,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kDAAkD;IAClD,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,oCAAoC;IACpC,WAAW;IACX,gDAAgD;IAChD,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,kDAAkD;IAClD,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;;IAGI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kDAAkD;IAClD,mCAAmC;AACvC;;AAEA;IACI;CACH;;AAED;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;IAEI;QACI,gDAAuD;IAC3D;;AAEJ;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["\n.header_unauth {\n    background: var(--white-color);\n    padding: var(--normal-margin-v) var(--double-margin-h);\n    /* box-shadow: var(--shadow); */\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: fixed;\n    height: 72px;\n    width: 100%;\n    z-index: 100;\n    top: 0;\n}\n\n\n\n.header__image {\n    height: var(--space-x2);\n}\n\n.header__search{\n    width: 230px;\n    float: right;\n}\n\n.header__actions {\n    display: grid;\n    grid-column-gap: var(--space-half);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.header__actions__home {\n    font-size: 28px;\n    margin-right: calc( var(--space-x2) + var(--space-half) );\n    cursor: pointer;\n    text-align: center;\n}\n\n.header__actions__home .baloa-username {\n    font-size: var(--space-half-quarter);\n    color: var(--basic-gray-color);\n}\n\n.header__actions__home .baloa-username.active {\n    color: var(--new-green-color);\n}\n\n.header__actions-icon.icon-plus {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n    border-radius: 50%;\n    padding: var(--space-half-quarter);\n    font-size: calc( var(--space) + var(--space-quarter) );\n}\n\n.header__actions__home .hubicon-live_tv1 {\n    color: var(--basic-gray-color);\n    font-size: 28px;\n}\n\n.header__actions__home.active .hubicon-live_tv-1 {\n    color: var(--new-green-color);\n    font-size: 28px;\n}\n\n.header__actions__home .icon-trophy {\n    color: var(--basic-gray-color);\n    font-size: 28px;\n}\n\n.header__actions__home.active .icon-trophy {\n    color: var(--new-green-color);\n    font-size: 28px;\n}\n\n.header__actions__home .icon-home {\n    color: var(--basic-gray-color);\n}\n\n.header__actions__home.active .icon-home {\n    color: var(--new-green-color);\n}\n\n.header_unauth__container {\n    display: flex;\n    align-items: center;\n}\n\n.header_unauth__search-container {\n    margin-left: calc( var(--space-x3) + var(--space) );\n    display: flex;\n    align-items: center;\n    width: 336px;\n}\n\n.header_unauth__search-container .icon-search {\n    position: absolute;\n    margin-left: var(--space-half-quarter);\n    font-size: var(--space-and-half);\n    color: #949F9A;\n}\n\n.header_unauth__search-container input {\n    height: calc( var(--space-x2) + var(--space-half) );\n    padding-left: var(--space-x3);\n    width: 100%;\n    border: none;\n    background-color: var(--new-gray-background-color);\n    border-radius: var(--space-and-half);\n}\n\n.header_unauth__search-container input.baloa-names {\n    color: #949F9A;\n}\n\n.header_unauth__search-container input:focus {\n    outline: none;\n}\n\n.header_unauth__login-button{\n    margin-left: 40px;\n}\n\n.header_unauth__mobile {\n    position: fixed;\n    top: 0;\n    background-color: var(--white-color);\n    width: 100%;\n    padding: calc( var(--space) + 2px ) var(--space);\n    z-index: 2;\n    display: flex;\n    align-items: center;\n}\n\n.header-unauth__mobile, \n.header-unauth__mobile-actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.header-unauth__mobile-actions {\n    justify-content: space-around;\n}\n\n.header-unauth__mobile-menu .hubicon-menu {\n    font-size: var(--space-x2);\n    color: var(--primary-very-dark-color);\n}\n\n.header-unauth__mobile-menu {\n    width: 30%;\n    display: flex;\n    align-items: center;\n}\n\n.header-unauth__mobile-menu .icon-search {\n    font-size: calc( var(--space) + 2px );\n    color: #949F9A;\n    background-color: var(--new-gray-background-color);\n    border-radius: 50%;\n    padding: var(--space-half);\n    margin-left: var(--space);\n    font-weight: bold;\n}\n\n.header-unauth__mobile-actions {\n    width: 70%;\n}\n\n.header-unauth__actions__mobile-home {\n    display: flex;\n    align-items: center;\n}\n\n.header-unauth__mobile-actions .header__actions__home,\n.header-unauth__mobile-actions .header_unauth__login-button {\n    margin: 0;\n}\n\n.header-unauth__mobile-actions .icon-home,\n.header-unauth__mobile-actions .icon-trophy,\n.header-unauth__mobile-actions .hubicon-live_tv1 {\n    font-size: var(--space-x2);\n}\n\n.header-unauth__mobile-actions .header__actions__home .hubicon-live_tv-1 {\n    font-size: var(--space-x2);\n}\n\n.header-unauth__mobile-actions .button {\n    font-size: var(--space);\n    padding: var(--space-half) var(--space-x2);\n}\n\n.header-unauth__mobile-actions .icon-plus {\n    background-color: var(--new-green-color);\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    padding: var(--space-half);\n    margin: 0;\n    border-radius: 50%;\n    color: var(--white-color);\n}\n\n.header-unauth__mobile__search-box {\n    display: flex;\n    align-items: center;\n    background-color: var(--white-color);\n    padding: 14px 16px;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 3;\n}\n\n.header-unauth__mobile__search-box .icon-arrow-left {\n    font-size: calc( var(--space) + var(--space-half));\n    margin-right: var(--space-and-half);\n}\n\n.header-unauth__mobile__search-box .search-form__form input[type=text] {\n    padding: var(--space-half) var(--space-half) var(--space-half) var(--space-x3)\n }\n\n.header-unauth__mobile__search-box .search-form__form .MuiSvgIcon-root {\n    margin: calc( var(--space-quarter) + 1px );\n}\n\n.header-unauthenticated__baloa-landing {\n    background-color: #EAF7F0;\n    padding: 12px;\n    gap: 8px;\n    white-space: nowrap;\n}\n\n@media screen and ( max-width: 576px ) {\n    \n    .header__image {\n        content: url(../../../assets/logos/baloa-logo-icon.svg);\n    }\n    \n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .header__actions__home {\n        font-size: unset;\n    }\n    .header__actions__home.active .icon-trophy {\n        font-size: var(--space-x2);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
